import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box form-container" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  class: "column",
  role: "form",
  "aria-label": "Form to create a new task"
}
const _hoisted_4 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timer = _resolveComponent("Timer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          placeholder: "Describe the activity you're about to start",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.taskDescription) = $event))
        }, null, 512), [
          [_vModelText, _ctx.taskDescription]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Timer, { onTimerFinished: _ctx.finishTask }, null, 8, ["onTimerFinished"])
      ])
    ])
  ]))
}